<template>
	<div class="page">
		<!-- 筛选 -->
		<div class="filter">
			<div class="filterName">类型：</div>
			<el-select v-model="operType" placeholder="请选择" class="titleSelect" style="width: 150px;" size="small"
				clearable @change="handelComClick">
				<el-option v-for="(item,index) in operTypes" :key="index" :label="item" :value="item" />
			</el-select>
			<div class="filterName">筛选日期：</div>
			<el-date-picker v-model="comDate" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" size="small" style="width: 220px;" @change="handelComClick">
			</el-date-picker>
			<div class="filterName" v-if="shopType == 0">门店：</div>
			<el-select v-model="shopId" placeholder="请选择" class="titleSelect" style="width: 100px;"
				size="small" @change="handelComClick" v-if="shopType == 0">
				<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-button type="warning" plain size="small" style="margin-left: 20px;" @click="resetClick">重置</el-button>
		</div>
		<!-- 表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="operCategoryType.title" label="类型" width="120">
			</el-table-column>
			<el-table-column prop="operTime" label="时间" width="200">
			</el-table-column>
			<el-table-column prop="operation_info.create.create_user.user_name" label="操作人" width="80">
				<template slot-scope="scope">
					{{scope.row.operation_info.create.create_user.user_name == ''?'--':scope.row.operation_info.create.create_user.user_name }}
				</template>
			</el-table-column>
			<el-table-column prop="content" label="事件">
				<template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="scope.row.content" placement="bottom">
						<span>{{scope.row.content}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<page :total="page.total" @change="changePage" :page="page.page" style="margin-top: 22px;"></page>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import {
		record,logfilter
	} from "@/api/purchaseApi.js"
	export default {
		components: {
			page
		},
		props: {
			shopType: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData: [],
				comDate: '', //筛选日期
				operType: '', //操作类型
				operTypes: [],
				shops: [{
					value: '',
					label: '全部'
				}, {
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				}, {
					value: '5e9412e0b2bfbc089daerr14',
					label: '指挥中心'
				}, {
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				},{
					value: '5e9412e0b2bfbc089daerr10',
					label: '驯养中心'
				}],
				shopId: '', //门店id
			}
		},
		mounted() {
			this.getTableData()
			this.getLogfilterData()
		},
		methods: {
			//筛选
			handelComClick(){
				this.page.page = 1;
				this.getTableData()
			},
			//重置
			resetClick() {
				this.page.page = 1;
				this.operType = '',
				this.comDate = '';
				if(this.shopType == 0){
					this.shopId = '';
				}
				this.getTableData()
			},
			//获取筛选
			getLogfilterData(){
				logfilter().then((res)=>{
					if(res.code == 0){
						this.operTypes = res.data
					}
				})
			},
			//获取数据
			getTableData() {
				let params = {
					pageIndex: this.page.page,
					pageSize: this.page.pageSize,
					operType: this.operType,
				}
				if (this.comDate != '') {
					params.bgnDate = new Date(this.comDate[0]).getTime() / 1000;
					params.endDate = new Date(this.comDate[1]).getTime() / 1000;
				}
				if (this.shopType == 0) {
					params.shopId = this.shopId
				} else {
					params.shopId = this.$store.state.shopId
				}
				record(params).then((res) => {
					if (res.code == 0) {
						console.log('操作记录', res)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		min-height: 762px;
		background: #fff;
		margin-top: 12px;
		font-size: 14px;

		.filter {
			height: 58px;
			display: flex;
			align-items: center;

			.sousuo {
				width: 153px;
				margin-right: 4px;
				margin-left: 16px;
			}

			.filterName {
				margin-left: 20px;
				margin-right: 4px;
			}
		}
	}
</style>
